<template>
<div>

  <section class="content">

      <!-- Default box -->
      <div class="box" v-if="canAccess('series-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Series Master</h3>
          <span class="pull-center">
            <button
              v-if="canAccess('series-update')"
              type="button"
              class="btn btn-sm btn-primary"
              @click="editModal(series)">
            <i class="fa fa-pencil"></i></button>
          </span>
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
          <div class="row">
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  
                  <h3 class="card-title">Member Series</h3>
                  
                </div>
                <!-- /.card-header -->
                <table class="table table-responsive table-bordered">
                  <thead>
                    <tr>
                      <th>Member Prefix</th>
                      <th>{{ series.memberPrefix }}</th>
                    </tr>
                    <tr>
                      <th>Member Series</th>
                      <th>{{ series.memberSeries }}</th>
                    </tr>
                    <tr>
                      <th>Branch Code Inclusion</th>
                      <th v-show="series.memberIncludeBranchCode == 'true'">
                        <span class="text-success">Yes</span>
                      </th>
                      <th v-show="series.memberIncludeBranchCode == 'false'">
                        <span class="text-danger">No</span>
                      </th>
                    </tr>
                  </thead>
                </table>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  
                  <h3 class="card-title">Employee/Agent Series</h3>
                  
                </div>
                <!-- /.card-header -->
                <table class="table table-responsive table-bordered">
                  <thead>
                    <tr>
                      <th>Employee/Agent Prefix</th>
                      <th>{{ series.agentPrefix }}</th>
                    </tr>
                    <tr>
                      <th>Employee/Agent Series</th>
                      <th>{{ series.agentSeries }}</th>
                    </tr>
                    <tr>
                      <th>Branch Code Inclusion</th>
                      <th v-show="series.agentIncludeBranchCode == 'true'">
                        <span class="text-success">Yes</span>
                      </th>
                      <th v-show="series.agentIncludeBranchCode == 'false'">
                        <span class="text-danger">No</span>
                      </th>
                    </tr>
                  </thead>
                </table>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->  
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  
                  <h3 class="card-title">Application Series</h3>
                  
                </div>
                <!-- /.card-header -->
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Application Series</th>
                      <th>{{ series.applicationSeries }}</th>
                    </tr>
                    <tr>
                      <th>Branch Code Inclusion</th>
                      <th v-show="series.applicationIncludeBranchCode == 'true'">
                        <span class="text-success">Yes</span>
                      </th>
                      <th v-show="series.applicationIncludeBranchCode == 'false'">
                        <span class="text-danger">No</span>
                      </th>
                    </tr>
                  </thead>
                </table>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
             <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  
                  <h3 class="card-title">Branch Series</h3>
                  
                </div>
                <!-- /.card-header -->
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Branch Prefix</th>
                      <th>{{ series.branchPrefix }}</th>
                    </tr>
                    <tr>
                      <th>Branch Series</th>
                      <th>{{ series.branchSeries }}</th>
                    </tr>
                  </thead>
                </table>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  
                  <h3 class="card-title">Collection Center Series</h3>
                  
                </div>
                <!-- /.card-header -->
                <table class="table table-responsive table-bordered">
                  <thead>
                    <tr>
                      <th>Collection Center Prefix</th>
                      <th>{{ series.collectionCenterPrefix }}</th>
                    </tr>
                    <tr>
                      <th>Collection Center Series</th>
                      <th>{{ series.collectionCenterSeries }}</th>
                    </tr>
                    <tr>
                      <th>Financial Year Inclusion</th>
                      <th v-show="series.collectionCenterIncludeYear == 'true'">
                        <span class="text-success">Yes</span>
                      </th>
                      <th v-show="series.collectionCenterIncludeYear == 'false'">
                        <span class="text-danger">No</span>
                      </th>
                    </tr>
                  </thead>
                </table>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  
                  <h3 class="card-title">Application Form Series</h3>
                  
                </div>
                <!-- /.card-header -->
                <table class="table table-responsive table-bordered">
                  <thead>
                    <tr>
                      <th>Application Form Prefix</th>
                      <th>{{ series.memberApplicationFormNoPrefix }}</th>
                    </tr>
                    <tr>
                      <th>Application Form Series</th>
                      <th>{{ series.memberApplicationFormNoSeries }}</th>
                    </tr>
                    <tr>
                      <th>Financial Year Inclusion</th>
                      <th v-show="series.memberApplicationFormNoIncludeYear == 'true'">
                        <span class="text-success">Yes</span>
                      </th>
                      <th v-show="series.memberApplicationFormNoIncludeYear == 'false'">
                        <span class="text-danger">No</span>
                      </th>
                    </tr>
                  </thead>
                </table>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  
                  <h3 class="card-title">Branch Center Series</h3>
                  
                </div>
                <!-- /.card-header -->
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Branch Center Prefix</th>
                      <th>{{ series.branchCenterPrefix }}</th>
                    </tr>
                    <tr>
                      <th>Branch Center Series</th>
                      <th>{{ series.branchCenterSeries }}</th>
                    </tr>
                  </thead>
                </table>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
          </div>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of Series
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>

      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              <h4 class="modal-title">Master Series Details</h4>
            </div>
            <form @submit.prevent="updateSeries()">
              <div class="modal-body">
                <!-- right column -->
                
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <h2>Member Series Update</h2>
                          <!-- text input -->
                          <div class="form-group">
                            <label>Member Prefix <span class="red">*</span></label>
                            <input v-model="form.memberPrefix" type="text" name="memberPrefix"
                              class="form-control" :class="{ 'is-invalid': form.errors.has('memberPrefix'), }" />
                            <has-error :form="form" field="memberPrefix"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Member Series <span class="red">*</span></label>
                            <input v-model="form.memberSeries" type="text" name="memberSeries"
                              class="form-control" :class="{ 'is-invalid': form.errors.has('memberSeries'), }" />
                            <has-error :form="form" field="memberSeries"></has-error>
                          </div>
                          <p><strong>Branch Code Inclusion </strong></p>
                          <div class="form-group">
                            <label>
                              <input type="radio" name="memberIncludeBranchCode" class="minimal" value="true"  v-model="form.memberIncludeBranchCode">
                              <i class="fa fa-check text-success"></i> <span class="text-success">Yes</span>
                              <has-error :form="form" field="memberIncludeBranchCode"></has-error>
                            </label>
                            <label>
                              <input type="radio" name="memberIncludeBranchCode" class="minimal" value="false"  v-model="form.memberIncludeBranchCode">
                              <i class="fa fa-remove text-danger"></i> <span class="text-danger">No</span>
                              <has-error :form="form" field="memberIncludeBranchCode"></has-error>
                            </label>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <!-- text input -->
                          <h2>Employee Series Update</h2>
                          <div class="form-group">
                            <label>Employee Prefix <span class="red">*</span></label>
                            <input v-model="form.agentPrefix" type="text" name="agentPrefix" class="form-control"
                              :class="{'is-invalid': form.errors.has('agentPrefix')}"/>
                            <has-error :form="form" field="agentPrefix"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Employee Series <span class="red">*</span></label>
                            <input v-model="form.agentSeries" type="text" name="agentSeries" class="form-control"
                              :class="{'is-invalid': form.errors.has('agentSeries'),}"/>
                            <has-error :form="form" field="agentSeries"></has-error>
                          </div>
                          <p><strong>Branch Code Inclusion </strong></p>
                          <div class="form-group">
                            <label>
                              <input type="radio" name="agentIncludeBranchCode" class="minimal" value="true"  v-model="form.agentIncludeBranchCode">
                              <i class="fa fa-check text-success"></i> <span class="text-success">Yes</span>
                              <has-error :form="form" field="agentIncludeBranchCode"></has-error>
                            </label>
                            <label>
                              <input type="radio" name="agentIncludeBranchCode" class="minimal" value="false"  v-model="form.agentIncludeBranchCode">
                              <i class="fa fa-remove text-danger"></i> <span class="text-danger">No</span>
                              <has-error :form="form" field="agentIncludeBranchCode"></has-error>
                            </label>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <!-- text input -->
                          <h2>Application Series Update</h2>
                          <div class="form-group">
                            <label>Application Series <span class="red">*</span></label>
                            <input v-model="form.applicationSeries" type="text" name="applicationSeries"
                              class="form-control" :class="{'is-invalid': form.errors.has('applicationSeries'),}" />
                            <has-error :form="form" field="applicationSeries" ></has-error>
                          </div>
                          <p><strong>Branch Code Inclusion </strong></p>
                          <div class="form-group">
                            <label>
                              <input type="radio" name="applicationIncludeBranchCode" class="minimal" value="true"  v-model="form.applicationIncludeBranchCode">
                              <i class="fa fa-check text-success"></i> <span class="text-success">Yes</span>
                              <has-error :form="form" field="applicationIncludeBranchCode"></has-error>
                            </label>
                            <label>
                              <input type="radio" name="applicationIncludeBranchCode" class="minimal" value="false"  v-model="form.applicationIncludeBranchCode">
                              <i class="fa fa-remove text-danger"></i> <span class="text-danger">No</span>
                              <has-error :form="form" field="applicationIncludeBranchCode"></has-error>
                            </label>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <h2>Branch Series Update</h2>
                          <!-- text input -->
                          <div class="form-group">
                            <label>Branch Prefix <span class="red">*</span></label>
                            <input v-model="form.branchPrefix" type="text" name="branchPrefix" class="form-control"
                              :class="{'is-invalid': form.errors.has('branchPrefix'),}"/>
                            <has-error :form="form" field="branchPrefix"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Branch Series <span class="red">*</span></label>
                            <input v-model="form.branchSeries" type="text" name="branchSeries" class="form-control"
                              :class="{'is-invalid': form.errors.has('branchSeries'),}"/>
                            <has-error :form="form" field="branchSeries"></has-error>
                          </div>
                          
                        </div>
                        <div class="col-md-6">
                          <h2>Collection Center Series Update</h2>
                          <!-- text input -->
                          <div class="form-group">
                            <label>Collection Center Prefix <span class="red">*</span></label>
                            <input v-model="form.collectionCenterPrefix" type="text" name="collectionCenterPrefix"
                              class="form-control" :class="{ 'is-invalid': form.errors.has('collectionCenterPrefix'), }" />
                            <has-error :form="form" field="collectionCenterPrefix"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Collection Center Series <span class="red">*</span></label>
                            <input v-model="form.collectionCenterSeries" type="text" name="collectionCenterSeries"
                              class="form-control" :class="{ 'is-invalid': form.errors.has('collectionCenterSeries'), }" />
                            <has-error :form="form" field="collectionCenterSeries"></has-error>
                          </div>
                          <p><strong>Financial Year Inclusion </strong></p>
                          <div class="form-group">
                            <label>
                              <input type="radio" name="collectionCenterIncludeYear" class="minimal" value="true"  v-model="form.collectionCenterIncludeYear">
                              <i class="fa fa-check text-success"></i> <span class="text-success">Yes</span>
                              <has-error :form="form" field="collectionCenterIncludeYear"></has-error>
                            </label>
                            <label>
                              <input type="radio" name="collectionCenterIncludeYear" class="minimal" value="false"  v-model="form.collectionCenterIncludeYear">
                              <i class="fa fa-remove text-danger"></i> <span class="text-danger">No</span>
                              <has-error :form="form" field="collectionCenterIncludeYear"></has-error>
                            </label>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <h2>Member Application Form Series Update</h2>
                          <!-- text input -->
                          <div class="form-group">
                            <label>Application Form Prefix <span class="red">*</span></label>
                            <input v-model="form.memberApplicationFormNoPrefix" type="text" name="memberApplicationFormNoPrefix"
                              class="form-control" :class="{ 'is-invalid': form.errors.has('memberApplicationFormNoPrefix'), }" />
                            <has-error :form="form" field="memberApplicationFormNoPrefix"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Application Form Series <span class="red">*</span></label>
                            <input v-model="form.memberApplicationFormNoSeries" type="text" name="memberApplicationFormNoSeries"
                              class="form-control" :class="{ 'is-invalid': form.errors.has('memberApplicationFormNoSeries'), }" />
                            <has-error :form="form" field="memberApplicationFormNoSeries"></has-error>
                          </div>
                          <p><strong>Financial Year Inclusion </strong></p>
                          <div class="form-group">
                            <label>
                              <input type="radio" name="memberApplicationFormNoIncludeYear" class="minimal" value="true"  v-model="form.memberApplicationFormNoIncludeYear">
                              <i class="fa fa-check text-success"></i> <span class="text-success">Yes</span>
                              <has-error :form="form" field="memberApplicationFormNoIncludeYear"></has-error>
                            </label>
                            <label>
                              <input type="radio" name="memberApplicationFormNoIncludeYear" class="minimal" value="false"  v-model="form.memberApplicationFormNoIncludeYear">
                              <i class="fa fa-remove text-danger"></i> <span class="text-danger">No</span>
                              <has-error :form="form" field="memberApplicationFormNoIncludeYear"></has-error>
                            </label>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <h2>Branch Center Series Update</h2>
                          <!-- text input -->
                          <div class="form-group">
                            <label>Branch Center Prefix <span class="red">*</span></label>
                            <input v-model="form.branchCenterPrefix" type="text" name="branchCenterPrefix" class="form-control"
                              :class="{'is-invalid': form.errors.has('branchCenterPrefix'),}"/>
                            <has-error :form="form" field="branchCenterPrefix"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Branch Center Series <span class="red">*</span></label>
                            <input v-model="form.branchCenterSeries" type="text" name="branchCenterSeries" class="form-control"
                              :class="{'is-invalid': form.errors.has('branchCenterSeries'),}"/>
                            <has-error :form="form" field="branchCenterSeries"></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                 
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">UPDATE</button>
                <button type="button" class="btn btn-danger" data-dismiss="modal">CANCEL</button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

</div>
</template>

<script>
export default {
  name: 'SeriesMaster',
  data () {
    return {
      form: new Form({
        id: '',
        memberPrefix: '',
        agentPrefix: '',
        branchPrefix: '',
        memberSeries: '',
        agentSeries: '',
        applicationSeries: '',
        branchSeries: '',
        branchCenterSeries: '',
        branchCenterPrefix: '',
        memberIncludeBranchCode: '',
        agentIncludeBranchCode: '',
        applicationIncludeBranchCode: '',
        memberApplicationFormNoSeries: '',
        memberApplicationFormNoIncludeYear: '',
        memberApplicationFormNoPrefix: '',
        collectionCenterIncludeYear: '',
        collectionCenterPrefix: '',
        collectionCenterSeries: '',
        inTime: '',
        outTime: '',
        status: ''
      }),
      series: {}
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    editModal (series) {
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(series)
    },
    updateSeries () {
      // console.log('update data');

      this.$axios
        .put('series/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Details Updated Successfully'
          })
        })
        .catch(() => {
          this.$Progress.start()
          Toast.fire({
            icon: 'error',
            title: 'Please Try Again'
          })
        })
    },
    loadData () {
      let loader = this.$loading.show()
      this.$axios
        .get('series?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          // console.log(data.data)
          this.series = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    }
  },
  created () {
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// SeriesMaster.vue?14e34a4c